<template>
  <div class="logo">
    <router-link :to="{ name: linkName, params: { locale: $i18n.locale } }" >
      <span @click="$emit('click')">
        <img src="../assets/images/logo.svg" alt="logo qic travel insurance">
        <div class="logo_add">
          <span>
            <slot name="logo-first-line">
              {{ $t('logo_first_line') }}
            </slot>
          </span>
          <i class="logoArrow"></i>
          <span>
            <slot name="logo-second-line">
              {{ $t('logo_second_line') }}
            </slot>
          </span>
          </div>
      </span>
    </router-link>
  </div> <!-- logo -->
</template>

<script>
export default {
  name: 'Logo',
  props: {
    linkName: { type: String, default: 'Home' }
  }
}
</script>
